(function () {
    'use strict';

    angular.module('app.sales',
        [
            'ui.bootstrap',
            'ngMessages',
            'ngSanitize',
            'ui.mask',
            'ui.utils.masks'
        ]);
})();